module.exports = __webpack_public_path__ + "img/9788949120959.9a6c3b7f.jpg";